import { create } from 'zustand'

interface ReplayStore {
    isReplayFinished: boolean
    isLinkCopied: boolean
    setIsReplayFinished: (isReplayFinished: boolean) => void
    setIsLinkCopied: (isLinkCopied: boolean) => void
}

export const useReplayStore = create<ReplayStore>((set) => ({
    isReplayFinished: false,
    isLinkCopied: false,
    setIsReplayFinished: (isReplayFinished) => {
        set({ isReplayFinished })
    },
    setIsLinkCopied: (isLinkCopied) => {
        set({ isLinkCopied })
    },
}))
